import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Button from "components/Button";
import Icon from "components/icons";

const CenterButton = styled(Button)`
  background-color: white;
  border: 0 none;
  border-radius: 0.625rem;
  filter: drop-shadow(0 0 0.25rem rgba(0, 0, 0, 0.25));
  margin: auto;
  position: absolute;
  top: 6.75rem;
  right: 0.625rem;
  width: 2.5rem;
  z-index: 1;

  path {
    opacity: 0.75;
    stroke: #666666;
  }
  &:hover,
  &:hover path {
    opacity: 1;
  }
`;

const SearchCenterMapButton = ({ map, currentLocation }) => {
  const handleRecenter = () => {
    map.setCenter({ lat: parseFloat(currentLocation?.latitude), lng: parseFloat(currentLocation?.longitude) });
  };
  return (
    <CenterButton outlineType="outline" outlineTransparent={false} onClick={handleRecenter}>
      <Icon name="mapCenter" />
    </CenterButton>
  );
};

export default SearchCenterMapButton;

SearchCenterMapButton.propTypes = {
  map: PropTypes.shape({
    setCenter: () => {},
  }).isRequired,
  currentLocation: PropTypes.shape({
    latitude: () => {},
    longitude: () => {},
  }).isRequired,
};
